export default ({ $config }) => {
  if (!$config.gTag) return;

  window.onNuxtReady(() => {
    // Defer Google Analytics until after app is fully interactive
    if (window.requestIdleCallback) {
      window.requestIdleCallback(loadGTag);
    } else {
      setTimeout(loadGTag, 2000);
    }
  });

  function loadGTag() {
    if (document.getElementById("gtag-script")) return;

    const script = document.createElement("script");
    script.id = "gtag-script";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${$config.gTag}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", $config.gTag);
  }
};
